// src/services/Api.js
import axios from 'axios';
import * as microsoftTeams from "@microsoft/teams-js";
import store from '../store';

import msalInstance, { accessTokenRequest } from './Auth';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

instance.interceptors.request.use(async (config) => {
  const state = store.getState();

  config.withCredentials = true;
  config.headers = config.headers || {};

  if (state.app.isMsTeamsApp) {
    return new Promise((resolve, reject) => {
      microsoftTeams.authentication.getAuthToken({
        successCallback: (token) => {
          config.headers.Authorization = `Bearer ${token}`;
          resolve(config);
        },
        failureCallback: (error) => {
          reject(error);
        }
      });
    });
  }

  let account = msalInstance.getActiveAccount();

  if (!account) {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      account = accounts[0];
      msalInstance.setActiveAccount(account);
    }
  }

  if (!account) {
    await msalInstance.loginRedirect({
      scopes: [process.env.REACT_APP_ADAL_API_SCOPE]
    });

    return Promise.reject(new Error("Redirecting for sign-in"));
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes: [process.env.REACT_APP_ADAL_API_SCOPE],
      account
    });

    if (response && response.accessToken) {
      config.headers.Authorization = `Bearer ${response.accessToken}`;
      return config;
    }

    return Promise.reject(new Error("No access token returned"));
  } catch (error) {
    if (error.name === "InteractionRequiredAuthError") {
      await msalInstance.acquireTokenRedirect({
        scopes: [process.env.REACT_APP_ADAL_API_SCOPE],
        account
      });
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
}, (error) => Promise.reject(error));

export default instance;


// WEBPACK FOOTER //
// ./src/services/Api.js